type RouteType = {
  url: string;
  meta: Record<string, unknown> & {
    isPage: boolean;
  };
};
type Route = {
  [key: string]: Route | RouteType;
};

export const APP_ROUTES = {
  root: {
    url: "/",
    meta: {
      isPage: true,
    },
  },
  login: {
    url: "/login",
    meta: {
      isPage: true,
    },
  },
  logout: {
    url: "/logout",
    meta: {
      isPage: true,
    },
  },
  oAuthCallback: {
    url: "/oauth_callback",
    meta: {
      isPage: true,
    },
  },
  home: {
    root: {
      url: "/home",
      meta: {
        isPage: true,
      },
    },
    overview: {
      url: "/home/overview",
      meta: {
        isPage: true,
      },
    },
    purchaseHistory: {
      url: "/home/purchase-history",
      meta: {
        isPage: true,
      },
    },
    paymentHistory: {
      url: "/home/payment-history",
      meta: {
        isPage: true,
      },
    },
    orderDetail: {
      url: "/home/order-detail/:code",
      meta: {
        isPage: false,
      },
    },
    installmentDetails: {
      url: "/home/installment/:code",
      meta: {
        isPage: false,
      },
    },

    profile: {
      root: {
        url: "/home/profile",
        meta: {
          isPage: false,
        },
      },
      account: {
        url: "/home/profile/account",
        meta: {
          isPage: false,
        },
      },
    },
  },
  pay: {
    root: {
      url: "/pay",
      meta: {
        isPage: true,
      },
    },
    choosePlan: {
      url: "/pay/choose-plan",
      meta: {
        isPage: true,
      },
    },
    setPlan: {
      url: "/pay/set-plan",
      meta: {
        isPage: true,
      },
    },
    getOrder: {
      root: {
        url: "/pay/get-order",
        meta: {
          isPage: true,
        },
      },
    },
    kuknospaymentCallback: {
      root: {
        url: "/pay/kuknospayment-callback",
        meta: {
          isPage: true,
        },
      },
    },
    epapaymentCallback: {
      root: {
        url: "/pay/epapayment-callback",
        meta: {
          isPage: true,
        },
      },
    },
    prepayCallback: {
      root: {
        url: "/pay/prepay-callback",
        meta: {
          isPage: true,
        },
      },
    },
    installmentVerifyCallback: {
      root: {
        url: "/pay/installment-verify-callback",
        meta: {
          isPage: true,
        },
      },
    },
  },
} as const satisfies Route;

function extractValues(obj: typeof APP_ROUTES) {
  const values: RouteType[] = [];

  function recurse(currentObject: typeof APP_ROUTES): void {
    Object.keys(currentObject).forEach((key) => {
      const value = currentObject[key as keyof typeof APP_ROUTES];

      if (typeof value === "object" && value !== null) {
        if ("url" in value) {
          values.push(value);
        }
        recurse(value as unknown as typeof APP_ROUTES);
      }
    });
  }

  recurse(obj);
  return values;
}

export const APP_ROUTES_ARRAY = () => extractValues(APP_ROUTES);
